import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AlertCardComponent, AlertType } from '../alert-card/alert-card.component';

/**
 * Indicador de etapas (steps) reutilizável: círculos numerados, rótulos e conectores,
 * com destaque para a etapa ativa e as concluídas, e card de alerta explicativo da etapa.
 *
 * Usado tanto na página de cadastro (variante card) quanto nos diálogos de wizard
 * (variante flush, encostada no header do diálogo — usar [flush]="true").
 *
 * Com [clicavel]="true", as etapas viram atalho: ao clicar, emite (passoSelecionado)
 * com o índice. Cabe ao componente pai decidir se permite a navegação (aplicando as
 * validações necessárias); este componente apenas emite o clique.
 */
@Component({
    selector: 'app-wizard-steps',
    standalone: true,
    imports: [CommonModule, MatIconModule, AlertCardComponent],
    templateUrl: './wizard-steps.component.html',
    styleUrl: './wizard-steps.component.css',
})
export class WizardStepsComponent {
    @Input({ required: true }) passos: string[] = [];
    @Input() passoAtual = 0;
    @Input() flush = false;
    @Input() clicavel = false;
    @Input() descricoes: string[] = [];
    @Input() tipoAlerta: AlertType = 'info';
    @Input() exibirAlerta = true;

    @Output() passoSelecionado = new EventEmitter<number>();

    public get tituloEtapaCorrente(): string {
        if (this.passos && this.passoAtual >= 0 && this.passoAtual < this.passos.length) {
            return this.passos[this.passoAtual];
        }
        return '';
    }

    public get descricaoEtapaCorrente(): string {
        if (this.descricoes && this.passoAtual >= 0 && this.passoAtual < this.descricoes.length) {
            return this.descricoes[this.passoAtual] || '';
        }
        return '';
    }

    public onPassoClick(indice: number): void {
        if (this.clicavel) this.passoSelecionado.emit(indice);
    }

}

